import { emsApi } from '@/api/emsApi';

type RequestedIncidentBody = {
  requestedIncidentId: string;
  phoneNumbers: string[];
};

function ensureSuccess(response: Response, action: string): void {
  if (!response.ok) {
    throw new Error(`${action} failed (HTTP ${response.status})`);
  }
}

export async function createIncident(requestedIncidentId: string, phoneNumbers: string[]): Promise<void> {
  const body: RequestedIncidentBody = { requestedIncidentId, phoneNumbers };
  const { response } = await emsApi.POST('/portal/v1/incident/create', { body });
  ensureSuccess(response, 'Create incident');
}

export async function locateCaller(requestedIncidentId: string, phoneNumbers: string[]): Promise<void> {
  const body: RequestedIncidentBody = { requestedIncidentId, phoneNumbers };
  const { response } = await emsApi.POST('/portal/v1/caller/locate', { body });
  ensureSuccess(response, 'Locate caller');
}

export async function startChatWithCaller(requestedIncidentId: string, phoneNumbers: string[]): Promise<void> {
  const body: RequestedIncidentBody = { requestedIncidentId, phoneNumbers };
  const { response } = await emsApi.POST('/portal/v1/caller/start-chat', { body });
  ensureSuccess(response, 'Start chat with caller');
}

export async function startVideoChatWithCaller(requestedIncidentId: string, phoneNumbers: string[]): Promise<void> {
  const body: RequestedIncidentBody = { requestedIncidentId, phoneNumbers };
  const { response } = await emsApi.POST('/portal/v1/caller/start-video-chat', { body });
  ensureSuccess(response, 'Start video chat with caller');
}
